export const adaptedCatalog: Record<string, {
    id?: string;
    state: 'adapted' | 'blocked';
    label: string;
}> = {
    mangadex: { id: 'mangadex', state: 'adapted', label: 'Adaptada' },
    leercapitulo: { id: 'leercapitulo', state: 'adapted', label: 'Adaptada' },
    kazokuden: { id: 'kazokuden', state: 'adapted', label: 'Adaptada' },
    anzmanga: { id: 'anzmanga', state: 'adapted', label: 'Adaptada' },
    dbnewhope: { id: 'dbnewhope', state: 'adapted', label: 'Adaptada' },
    marmota: { id: 'marmota', state: 'adapted', label: 'Adaptada' },
    enchiladascan: { id: 'enchiladascan', state: 'adapted', label: 'Adaptada' },
    inmanga: { id: 'inmanga', state: 'adapted', label: 'Adaptada' },
    olympusscanlation: { id: 'olympusscanlation', state: 'adapted', label: 'Adaptada' },
    novelcool: { id: 'novelcool', state: 'adapted', label: 'Adaptada' },
    mangafire: { state: 'blocked', label: 'Requiere verificación del sitio' },
    mangamillion: { state: 'blocked', label: 'API bloqueada · HTTP 403' },
    plottwistnofansub: { state: 'blocked', label: 'Protección antibots' },
};
export function adaptationFor(pkg: string) { return adaptedCatalog[pkg.split('.').pop() || '']; }
export const keiyoushiRepository = 'https://raw.githubusercontent.com/keiyoushi/extensions/repo/index.pb';
